import i18n from "../../../../utils/i18n";
import classes from "./newCompanyType.module.scss";

const Radio = ({ checked }) => (
  <span
    className={`${classes.radio} ${checked ? classes.radioChecked : ""}`}
    aria-hidden="true"
  />
);

const NEW_COMPANY_TYPE_OPTIONS = [
  {
    value: "reg",
    emoji: "👨‍💼",
    title: i18n.t("searchflow.newcompanytypeevtitle"),
    subtitle: i18n.t("searchflow.newcompanytypeevsubtitle"),
  },
  {
    value: "kftreg",
    emoji: "💼",
    title: i18n.t("searchflow.newcompanytypekfttitle"),
    subtitle: i18n.t("searchflow.newcompanytypekftsubtitle"),
  },
  {
    value: "vaf",
    emoji: "🤔",
    title: i18n.t("searchflow.newcompanytypevaftitle"),
    subtitle: i18n.t("searchflow.newcompanytypevafsubtitle"),
  },
];

const NewCompanyType = ({
  regCompanyTypeSelection,
  setRegCompanyTypeSelection,
}) => {
  return (
    <div className={classes.root}>
      <div className={classes.scrollArea}>
        <div className={classes.content}>
          <div className={classes.mainColumn}>
            <header className={classes.header}>
              <h1 className={classes.title}>
                {i18n.t("searchflow.newcompanytypetitle")}
              </h1>
              <p className={classes.subtitle}>
                {i18n.t("searchflow.newcompanytypesubtitle")}
              </p>
            </header>

            <div className={classes.rightColumn}>
              <div className={classes.cardsContainer}>
                {NEW_COMPANY_TYPE_OPTIONS.map((option) => {
                  const isSelected = regCompanyTypeSelection === option.value;

                  return (
                    <button
                      key={option.value}
                      type="button"
                      className={`${classes.card} ${isSelected ? classes.selectedRow : ""}`}
                      onClick={() => setRegCompanyTypeSelection(option.value)}
                      aria-pressed={isSelected}
                    >
                      <span className={classes.cardEmoji} role="img" aria-hidden="true">
                        {option.emoji}
                      </span>
                      <div className={classes.cardContent}>
                        <div className={classes.cardTitle}>{option.title}</div>
                        {option.subtitle && (
                          <div className={classes.cardSubtitle}>{option.subtitle}</div>
                        )}
                      </div>
                      <Radio checked={isSelected} />
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewCompanyType;
